import { NewReport, Report } from '@pubstack/common/src/report'
import { MutationToasts, useMutation, useQuery } from '~/api/api-client'

export const REPORTS_QUERY_KEYS = ['reports']

//-------------------------------------------------------------------------

// Queries

//-------------------------------------------------------------------------

export const useReports = () => {
  const queryResult = useQuery<Report[]>({ url: '/reports', keys: REPORTS_QUERY_KEYS })

  return { ...queryResult, data: queryResult.data || [] }
}

//-------------------------------------------------------------------------
// Mutations
//-------------------------------------------------------------------------

export const useCreateReport = (toasts: MutationToasts = {}) => {
  return useMutation<NewReport>({
    method: 'post',
    url: '/reports',
    collectionKeys: REPORTS_QUERY_KEYS,
    ...toasts,
  })
}

export const useDeleteReport = (reportId: string, toasts: MutationToasts = {}) => {
  return useMutation<void>({
    method: 'delete',
    url: `/reports/${reportId}`,
    collectionKeys: REPORTS_QUERY_KEYS,
    resourceId: reportId,
    ...toasts,
  })
}
